<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <side-bar :backgroundColor="colorBackground" id="sidebar">
      <mobile-menu></mobile-menu>
      <template v-if="menus.length > 0 && this.userLogged" slot="links">
        <sidebar-item
          v-if="isMenuVisible('/operativa')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Operativa',
            icon: 'nc-icon nc-delivery-fast',
            path: '*',
          }"
        >
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Envíos',
              path: '/franquiciadora/envios',
            }"
            v-if="isMenuVisible('/franquiciadora/envios')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'RMA',
              path: '/franquiciadora/rma',
            }"
            v-if="isMenuVisible('/franquiciadora/rma')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Extraviados',
              path: '/franquiciadora/extraviados',
            }"
            v-if="isMenuVisible('/franquiciadora/extraviados')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Envíos agrupados',
              path: '/franquiciadora/envios-agrupados',
            }"
            v-if="isMenuVisible('/franquiciadora/envios-agrupados')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Incoterms ',
              path: '/franquiciadora/incoterms-sended',
            }"
            v-if="isMenuVisible('/franquiciadora/incoterms-sended')"
          />
        </sidebar-item>
        <sidebar-item
          v-if="
            isMenuVisible('/recogidas') &&
            (isMenuVisible('/franquiciadora/recogidas/propias') ||
              isMenuVisible('/franquiciadora/recogidas/otras-plazas') ||
              isMenuVisible('/franquiciadora/recogidas/partner'))
          "
          :hideItem="ocultarItem"
          :link="{
            name: 'Recogidas',
            icon: 'nc-icon nc-pickup',
            path: '*',
          }"
        >
          <sidebar-item
            v-if="isMenuVisible('/franquiciadora/recogidas/propias')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Propias',
              path: '/franquiciadora/recogidas/propias',
            }"
          />
          <sidebar-item
            v-if="isMenuVisible('/franquiciadora/recogidas/otras-plazas')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Otras plazas',
              path: '/franquiciadora/recogidas/otras-plazas',
            }"
          />
          <sidebar-item
            v-if="isMenuVisible('/franquiciadora/recogidas/partner')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Partner',
              path: '/franquiciadora/recogidas/partner',
            }"
          />
        </sidebar-item>
        <sidebar-item
          v-if="
            isMenuVisible('/entregas') &&
            isMenuVisible('/franquiciadora/entregas/propias')
          "
          :hideItem="ocultarItem"
          :link="{ name: 'Entregas', icon: 'nc-icon nc-delivery', path: '*' }"
        >
          <sidebar-item
            v-if="isMenuVisible('/franquiciadora/entregas/propias')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Propias',
              path: '/franquiciadora/entregas/propias',
            }"
          />
        </sidebar-item>
        <sidebar-item
          :hideItem="ocultarItem"
          :link="{
            name: 'Gestión de Incidencias',
            icon: 'nc-icon nc-settings-tool-66',
            path: '/franquiciadora/incidencias',
          }"
          v-if="isMenuVisible('/franquiciadora/incidencias')"
        />
        <sidebar-item
          v-if="isMenuVisible('/franquiciadora/expedientes')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Expedientes',
            icon: 'nc-icon nc-single-copy-04',
            path: '*',
          }"
        >
          <sidebar-item
            v-if="isMenuVisible('/franquiciadora/expedientes/medidas')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Pesos y Medidas',
              path: '/franquiciadora/expedientes/medidas',
            }"
          />
          <sidebar-item
            v-if="isMenuVisible('/franquiciadora/expedientes/servicios')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Garantías de servicio',
              path: '/franquiciadora/expedientes/servicios',
            }"
          />
          <sidebar-item
            v-if="isMenuVisible('/franquiciadora/expedientes/siniestros')"
            :hideItem="ocultarItem"
            :link="{
              name: 'Siniestros',
              path: '/franquiciadora/expedientes/siniestros',
            }"
          />
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/importaciones')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Importaciones',
            icon: 'nc-icon nc-cloud-upload-94',
            path: '*',
          }"
        >
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Envios',
              path: '/franquiciadora/importaciones',
            }"
            v-if="isMenuVisible('/franquiciadora/importaciones')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'RMA',
              path: '/franquiciadora/importacionesRma',
            }"
            v-if="isMenuVisible('/franquiciadora/importacionesRma')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Otros',
              path: '/franquiciadora/importacionesOtros',
            }"
            v-if="isMenuVisible('/franquiciadora/importacionesOtros')"
          />
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/facturacion')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Facturación',
            icon: 'nc-icon nc-paper-2',
            path: '*',
          }"
        >
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Control de Valoraciones',
              path: '/franquiciadora/control-valoracion',
            }"
            v-if="isMenuVisible('/franquiciadora/control-valoracion')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Tarifas Cliente',
              path: '/franquiciadora/tarifas-cliente',
            }"
            v-if="isMenuVisible('/franquiciadora/tarifas-cliente')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Tarifas Franquicia',
              path: '/franquiciadora/tarifas',
            }"
            v-if="isMenuVisible('/franquiciadora/tarifas')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Tarifas Partner',
              path: '/franquiciadora/tarifasPartner',
            }"
            v-if="isMenuVisible('/franquiciadora/tarifasPartner')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Documentación',
              path: '/franquiciadora/documentacion',
            }"
            v-if="isMenuVisible('/franquiciadora/documentacion')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Ficheros master',
              path: '/franquiciadora/fichero-master',
            }"
            v-if="isMenuVisible('/franquiciadora/fichero-master')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Procesos',
              path: '/franquiciadora/procesos',
            }"
            v-if="isMenuVisible('/franquiciadora/procesos')"
          />
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/maestros')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Maestros',
            icon: 'nc-icon nc-layers-3',
            path: '*',
          }"
        >
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Puntos de Red',
              path: '/franquiciadora/puntosred',
            }"
            v-if="isMenuVisible('/franquiciadora/puntosred')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Estados',
              path: '/franquiciadora/estados',
            }"
            v-if="isMenuVisible('/franquiciadora/estados')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Estados Paradas',
              path: '/franquiciadora/estados-paradas',
            }"
            v-if="isMenuVisible('/franquiciadora/estados-paradas')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Servicios',
              path: '/franquiciadora/servicios',
            }"
            v-if="isMenuVisible('/franquiciadora/servicios')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Geográficos',
              path: '/franquiciadora/geograficos',
            }"
            v-if="isMenuVisible('/franquiciadora/geograficos')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Geográfico Servicios',
              path: '/franquiciadora/geografico-servicios',
            }"
            v-if="isMenuVisible('/franquiciadora/geografico-servicios')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Fecha Cierre',
              path: '/franquiciadora/fecha-cierre',
            }"
            v-if="isMenuVisible('/franquiciadora/fecha-cierre')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Reglas de Tránsito',
              path: '/franquiciadora/regla-transito',
            }"
            v-if="isMenuVisible('/franquiciadora/regla-transito')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Borrados',
              path: '/franquiciadora/borrados',
            }"
            v-if="isMenuVisible('/franquiciadora/borrados')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Vistas Control',
              path: '/franquiciadora/control-vistas',
            }"
            v-if="isMenuVisible('/franquiciadora/control-vistas')"
          />

          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Impuestos',
              path: '/franquiciadora/impuestos',
            }"
            v-if="isMenuVisible('/franquiciadora/impuestos')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Soluciones',
              path: '/franquiciadora/soluciones',
            }"
            v-if="isMenuVisible('/franquiciadora/soluciones')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Soluciones Reglas',
              path: '/franquiciadora/soluciones-reglas',
            }"
            v-if="isMenuVisible('/franquiciadora/soluciones-reglas')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Palets',
              path: '/franquiciadora/palets',
            }"
            v-if="isMenuVisible('/franquiciadora/palets')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Palets Hubs',
              path: '/franquiciadora/palets-hubs',
            }"
            v-if="isMenuVisible('/franquiciadora/palets-hubs')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Tarifas Palets',
              path: '/franquiciadora/tarifas-palets',
            }"
            v-if="isMenuVisible('/franquiciadora/tarifas-palets')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Tarifas Genéricos',
              path: '/franquiciadora/tarifas-genericos',
            }"
            v-if="isMenuVisible('/franquiciadora/tarifas-genericos')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Incoterms',
              path: '/franquiciadora/incoterms',
            }"
            v-if="isMenuVisible('/franquiciadora/incoterms')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Partners',
              path: '/franquiciadora/partners',
            }"
            v-if="isMenuVisible('/franquiciadora/partners')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Seguro',
              path: '/franquiciadora/seguro-config',
            }"
            v-if="isMenuVisible('/franquiciadora/seguro-config')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Poblaciones',
              path: '/franquiciadora/poblaciones',
            }"
            v-if="isMenuVisible('/franquiciadora/poblaciones')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Plantillas WhatsApp',
              path: '/franquiciadora/templates-whatsapp',
            }"
            v-if="isMenuVisible('/franquiciadora/templates-whatsapp')"
          />
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/Logistica')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Logística',
            icon: 'nc-icon nc-tag-content',
            path: '*',
          }"
        >
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Almacenes',
              path: '/franquiciadora/logistica/almacenes',
            }"
            v-if="isMenuVisible('/franquiciadora/logistica/almacenes')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Medidas',
              path: '/franquiciadora/logistica/medidas',
            }"
            v-if="isMenuVisible('/franquiciadora/logistica/medidas')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Areas',
              path: '/franquiciadora/logistica/areas',
            }"
            v-if="isMenuVisible('/franquiciadora/logistica/areas')"
          />
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/franquiciadora/franquicias')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Franquicias',
            icon: 'nc-icon nc-bank',
            path: '/franquiciadora/franquicias',
          }"
        />
        <sidebar-item
          v-if="isMenuVisible('/franquiciadora/clientes')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Clientes',
            icon: 'nc-icon nc-single-02',
            path: '/franquiciadora/clientes',
          }"
        />
        <sidebar-item
          v-if="isMenuVisible('/Mobile')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Mobile',
            icon: 'nc-icon nc-mobile',
            path: '*',
          }"
        >
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Eventos',
              path: '/franquiciadora/eventos',
            }"
            v-if="isMenuVisible('/franquiciadora/eventos')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Configuración',
              path: '/franquiciadora/gestion-configuracion',
            }"
            v-if="isMenuVisible('/franquiciadora/gestion-configuracion')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Repartidores',
              path: '/franquiciadora/repartidores-realizan-eventos',
            }"
            v-if="
              isMenuVisible('/franquiciadora/repartidores-realizan-eventos')
            "
          />
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/integraciones')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Integraciones',
            icon: 'nc-icon nc-puzzle-10',
            path: '*',
          }"
        >
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Errores Courier',
              path: '/franquiciadora/error-courier',
            }"
            v-if="isMenuVisible('/franquiciadora/error-courier')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Ficheros Sorter',
              path: '/franquiciadora/ficheros-sorter',
            }"
            v-if="isMenuVisible('/franquiciadora/ficheros-sorter')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Plataforma Integración',
              path: '/franquiciadora/plataforma-integracion',
            }"
            v-if="isMenuVisible('/franquiciadora/plataforma-integracion')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Plataforma Integración Config',
              path: '/franquiciadora/configuracion-integracion',
            }"
            v-if="isMenuVisible('/franquiciadora/configuracion-integracion')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Servicios Renombrados',
              path: '/franquiciadora/renombrar-servicios',
            }"
            v-if="isMenuVisible('/franquiciadora/renombrar-servicios')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Servicios Seur',
              path: '/franquiciadora/servicios-seur',
            }"
            v-if="isMenuVisible('/franquiciadora/servicios-seur')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Mobile Queue',
              path: '/franquiciadora/mobile-queue',
            }"
            v-if="isMenuVisible('/franquiciadora/mobile-queue')"
          />
        </sidebar-item>
        <sidebar-item
          :hideItem="ocultarItem"
          :link="{
            name: 'Notificaciones',
            icon: 'nc-icon nc-bell-55',
            path: '',
          }"
          v-if="isMenuVisible('/notificaciones')"
        >
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Email',
              path: '/franquiciadora/integraciones-notificaciones',
            }"
            v-if="isMenuVisible('/franquiciadora/integraciones-notificaciones')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'WhatsApp',
              path: '/franquiciadora/whatsapp',
            }"
            v-if="isMenuVisible('/franquiciadora/whatsapp')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Portales',
              path: '/franquiciadora/notificaciones-dashboard',
            }"
            v-if="isMenuVisible('/franquiciadora/notificaciones-dashboard')"
          />
        </sidebar-item>
        <sidebar-item
          v-if="isMenuVisible('/autorizacion')"
          :hideItem="ocultarItem"
          :link="{
            name: 'Autorización',
            icon: 'nc-icon nc-key-25',
            path: '*',
          }"
        >
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Api Keys',
              path: '/franquiciadora/autorizacion',
            }"
            v-if="isMenuVisible('/franquiciadora/autorizacion')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Usuarios',
              path: '/franquiciadora/usuarios',
            }"
            v-if="isMenuVisible('/franquiciadora/usuarios')"
          />
          <sidebar-item
            :hideItem="ocultarItem"
            :link="{
              name: 'Menú roles',
              path: '/franquiciadora/menu-roles',
            }"
            v-if="isMenuVisible('/franquiciadora/menu-roles')"
          />
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "@/assets/css/parcel-icons.css";

// Menús de la última carga correcta (roles.service los guarda al recibirlos)
function menusGuardados() {
  try {
    const menus = JSON.parse(localStorage.getItem("roles-menu"));
    return Array.isArray(menus) ? menus : [];
  } catch (e) {
    return [];
  }
}

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  data() {
    return {
      ocultarItem: "mostrarme",
      ro: null,
      colorBackground: "black",
      // Se pinta con los guardados mientras llegan los actuales: si la petición
      // falla, el menú no se queda en blanco
      menus: menusGuardados(),
      reintentosMenus: 0,
      userLogged: null,
    };
  },
  computed: {
    menusStatus() {
      return this.$store.state.roles.menusMaster.status;
    },
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        docClasses.add("perfect-scrollbar-off");
      } else {
        initScrollbar("main-panel");

        docClasses.add("perfect-scrollbar-on");
      }
    },
    onResize() {
      const sidebar = document.getElementById("sidebar");
      if (!sidebar) return;

      const val = sidebar.clientWidth;
      if (val == 80) {
        this.ocultarItem = "ocultarme";
      } else {
        this.ocultarItem = "mostrarme";
      }
    },
    isMenuVisible(route) {
      if (this.userLogged.roles.includes("ADMIN")) return true;
      const item = this.menus.find((item) => item.key == route);
      if (!item) return true;
      if (item.roles.length <= 0) return true;
      if (!this.userLogged.rolesMenu) {
        return false;
      }
      return item.roles.some((elemento) =>
        this.userLogged.rolesMenu.includes(elemento)
      );
    },
    getMenus() {
      this.$store.dispatch("roles/getMenusMaster");
    },
    getCountries() {
      this.$store.dispatch("geoname/getPaises");
    },
  },
  mounted() {
    if (process.env.NODE_ENV === "production") {
      this.colorBackground = "black";
    } else this.colorBackground = "purple";
    this.$sidebar.ocultarSideBar();
    /* document.body.classList.toggle('sidebar-mini') */
    this.initScrollbar();
    this.ro = new ResizeObserver(this.onResize);
    let side = document.getElementById("sidebar");
    this.ro.observe(side);
    this.userLogged = JSON.parse(localStorage.getItem("user"));
    this.getMenus();
    this.getCountries();
  },
  beforeUnmount() {
    if (this.ro) {
      this.ro.disconnect();
    }
  },
  watch: {
    menusStatus(val) {
      if (val.loaded) {
        this.menus = this.$store.state.roles.menusMaster.data.master || [];
      } else if (val.error && this.menus.length === 0 && this.reintentosMenus < 2) {
        // Sin menús guardados (primer acceso): se reintenta antes de dejarlo vacío
        this.reintentosMenus++;
        setTimeout(() => {
          if (localStorage.getItem("user")) this.getMenus();
        }, 2000);
      }
    },
  },
};
</script>
